import React, { useState } from "react";

const PlayerNamePrompt = ({ onSubmit }) => {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError("Please enter a display name.");
      return;
    }
    if (name.trim().length < 2) {
      setError("Name must be at least 2 characters long.");
      return;
    }
    if (name.trim().length > 20) {
      setError("Name must be 20 characters or less.");
      return;
    }
    setError("");
    onSubmit(name.trim());
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 max-w-md mx-auto">
      <div className="text-center mb-6">
        <div className="bg-indigo-100 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
          <svg className="w-8 h-8 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Choose Your Display Name</h2>
        <p className="text-gray-600">This name will be visible to other players in the game and chat.</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Display Name</label>
          <input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            className="w-full border-2 border-gray-300 rounded-lg px-4 py-3 focus:border-indigo-500 focus:outline-none text-lg"
            maxLength={20}
            placeholder="Enter your name"
            autoFocus
          />
          <div className="text-xs text-gray-500 mt-1">
            {name.length}/20 characters
          </div>
        </div>
        
        {error && (
          <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}
        
        <button 
          type="submit" 
          className="w-full bg-indigo-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-indigo-700 transition-colors text-lg"
          disabled={!name.trim()}
        >
          Continue
        </button>
      </form>
      
      <div className="mt-4 text-center text-xs text-gray-500">
        Your name will be used in chat and leaderboards
      </div>
    </div>
  );
};

export default PlayerNamePrompt;
